"use strict";
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        /**
         * Hosts the SysAppDesignerPane X++ form in the Task Recorder pane.
         * Move to separate file if there are more logic in future
         */
        var AppDesignerPane = /** @class */ (function () {
            function AppDesignerPane(data, element) {
                this.VisiblePane = $dyn.observable(true);
            }
            AppDesignerPane.prototype.close = function () {
                $dyn.ax.appDesigner.close();
            };
            return AppDesignerPane;
        }());
        ax.AppDesignerPane = AppDesignerPane;
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=AppDesignerPane.js.map
